import React from 'react';
import { useGetAllElementsForRemoteSubmissionSuspense, useGetAllLocationsForRemoteSubmissionSuspense, useGetAllLocationTypesForRemoteSubmissionSuspense, } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { useRemoteSubmissionContext } from './RemoteSubmissionProvider';
import RemoteSubmissionForm from './RemoteSubmissionForm';
const RemoteSubmissionFormWrapper = () => {
    const { token } = useRemoteSubmissionContext();
    const { data: locationTypesResponse } = useGetAllLocationTypesForRemoteSubmissionSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const { data: locationsResponse } = useGetAllLocationsForRemoteSubmissionSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const { data: elementsResponse } = useGetAllElementsForRemoteSubmissionSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const elements = unwrapModel(elementsResponse);
    const locationTypes = unwrapModel(locationTypesResponse);
    const locations = unwrapModel(locationsResponse);
    if (!elements || !locationTypes || !locations)
        return null;
    return (React.createElement(RemoteSubmissionForm, { elements: elements, locationTypes: locationTypes, locations: locations }));
};
export default RemoteSubmissionFormWrapper;
